import React, { FC } from "react";
import { makeStyles, MenuItem, Select } from "@material-ui/core";
import { Pagination as MUIPagination } from "@material-ui/lab";

const useStyles = makeStyles(() => ({
  paginationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 24,
  },
  paginationInfo: {
    width: 160,
  },
  itemsPerPage: {
    "& .MuiSelect-select": {
      fontSize: 14,
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "unset",
    },
    "& > .MuiInput-root::before": {
      content: "unset",
    },
    "& > .MuiInput-root::after": {
      content: "unset",
    },
  },
}));

export interface IPaginationConfig {
  page: number;
  limit: number;
}

interface IPaginationProps {
  totalCount: number;
  config?: IPaginationConfig;
  onChange?: (config: IPaginationConfig) => void;
  label?: string;
}

export const InitialPaginationConfig: IPaginationConfig = {
  limit: 15,
  page: 1,
};

const Pagination: FC<IPaginationProps> = ({
  totalCount,
  config = InitialPaginationConfig,
  onChange = () => {},
  label = "items",
}) => {
  const classes = useStyles();

  const page = config.page;
  const itemsPerPage = config.limit;

  const totalPagesCount = Math.ceil(totalCount / itemsPerPage);
  const startToSlice = (page - 1) * itemsPerPage;
  const endToSlice = startToSlice + itemsPerPage;
  const startToDisplay = startToSlice + 1;
  const endToDisplay = Math.min(totalCount, endToSlice);

  const onPageChange = (_, value) => onChange({ ...config, page: value });
  const onLimitChange = (e) =>
    onChange({ page: InitialPaginationConfig.page, limit: e.target.value });

  return (
    <div className={classes.paginationContainer}>
      <div className={classes.paginationInfo}>
        {`${startToDisplay} - ${endToDisplay} of ${totalCount}`}
      </div>
      <MUIPagination
        count={totalPagesCount}
        onChange={onPageChange}
        page={page}
      />
      <div className={classes.itemsPerPage}>
        <Select value={itemsPerPage} onChange={onLimitChange}>
          {[5, 15, 25].map((count) => (
            <MenuItem key={count} value={count}>
              {count}
            </MenuItem>
          ))}
        </Select>
        <span>{`${label} per page`}</span>
      </div>
    </div>
  );
};

export default Pagination;
